export class BusinessRelationshipV11 {
    static constructFromPlainObjectList(objectList) {
        const typedObjects = [];
        if (objectList && Array.isArray(objectList)) {
            for (const obj of objectList) {
                typedObjects.push(new BusinessRelationshipV11(obj.businessNumber, obj.vehicleType, obj.brands));
            }
        }
        return typedObjects;
    }
    constructor(businessNumber, vehicleType, brands) {
        this.businessNumber = businessNumber;
        this.vehicleType = vehicleType;
        this.brands = brands;
    }
    getBusinessNumber() {
        return this.businessNumber;
    }
    getVehicleType() {
        return this.vehicleType;
    }
    getBrands() {
        return this.brands;
    }
}
//# sourceMappingURL=businessRelationshipV11.js.map